import { parseConfigStringToJSON, parseToolChestStringToJSON } from '@/libs/parseQueryConfig';
import { casesLib } from '@/Constants/casesLib';

function fixColorString(color: string) {
    color = color.replace(/^%23/, '');
    return '#' + color;
}

export function parseUrlConfig(dataInCaseItems: string, dataInToolChest: string) {
    if (!dataInCaseItems && !dataInToolChest) {
        return;
    }

    const dataOutCaseItems = parseConfigStringToJSON(dataInCaseItems);
    const dataOutToolChest = parseToolChestStringToJSON(dataInToolChest);

    if (dataOutToolChest.colorFrame[0] === '%') {
        dataOutToolChest.colorFrame = fixColorString(dataOutToolChest.colorFrame);
    }
    if (dataOutToolChest.colorFace[0] === '%') {
        dataOutToolChest.colorFace = fixColorString(dataOutToolChest.colorFace);
    }

    const actualToolChest = casesLib.find(x => x.id === dataOutToolChest.blenderName);
    const dataOut = {
        caseItems: dataOutCaseItems,
        blenderName: dataOutToolChest.blenderName,
        selectedCaseModel: actualToolChest?.key,
        colorFrame: dataOutToolChest.colorFrame,
        colorFace: dataOutToolChest.colorFace,
        isCloseDoors: dataOutToolChest.isCloseDoors,
        drawerSeparators: dataOutToolChest.drawerSeparators,
        expandedDrawersPrototypeId: dataOutToolChest.expandedDrawersPrototypeId,
    };
    // console.log('Preset out:', dataOut);
    return dataOut;
}
